// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g_qK","col":"styles_col__1qgFn"};